// extracted by mini-css-extract-plugin
module.exports = {"container":"NotifiesApartmentRenderer_container_281DB","number":"NotifiesApartmentRenderer_number_3Yk_M"};